import { getBaseUrlB2B } from "../AuthService/BaseURLS";
import { axiosWithToken } from "../AuthService/AxiosToken";
import getTenantByPayerName from "../Helpers/getTenantByPayerName";
import { getB2BTokens } from "../AuthService/userData";
export function deleteNotifications (data) {
    let B2BTokens = getB2BTokens()[0];
    return new Promise((resolve, reject) => {
        axiosWithToken.put(getBaseUrlB2B() + `/messages/notification/provider/${B2BTokens.providerBranchInfo.id}`,undefined,{
            headers: {
                "Authorization": `Bearer ${getTenantByPayerName(B2BTokens.payerName).accessToken}`,
                "payername": B2BTokens.payerName,
            }
        } )
            .then(response => {   
                resolve(response.data);
            })
            .catch(error => {
                reject(error)
            })
    })
}